// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-height: 100vh;
  color: #fff;
}

/* The page consumes the shared --ca-* design tokens from styles.scss. */
.products-header {
  position: relative;
  z-index: 5;
  width: 100%;
  background: rgba(7, 17, 46, 0.96);
  border-bottom: 1px solid rgba(185, 205, 242, 0.14);
  box-shadow: 0 8px 28px rgba(1, 8, 23, 0.12);
  backdrop-filter: blur(18px);
}

.products-header__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  width: min(100%, 1600px);
  min-height: 78px;
  margin: 0 auto;
  padding: 0 clamp(1rem, 4vw, 3.5rem);
}

.brand-lockup,
.header-actions,
.header-action,
.user-management-btn {
  display: inline-flex;
  align-items: center;
}

.brand-lockup {
  flex: 0 1 auto;
  gap: 1rem;
  min-width: 0;
}

.brand-lockup__logo {
  display: block;
  width: auto;
  max-width: 160px;
  height: 38px;
  object-fit: contain;
}

.brand-lockup__divider,
.header-actions__divider {
  width: 1px;
  height: 28px;
  background: rgba(220, 229, 245, 0.22);
}

.brand-lockup__caption {
  color: #aabbd9;
  font-size: 0.67rem;
  font-weight: 700;
  letter-spacing: 0.13em;
  white-space: nowrap;
}

.header-actions {
  justify-content: flex-end;
  gap: clamp(0.6rem, 1.5vw, 1.35rem);
  min-width: 0;
}

.header-action {
  gap: 0.55rem;
  padding: 0.7rem 0.25rem;
  color: #d7e2f5;
  font-size: 0.86rem;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  transition: color 180ms ease;
}

.header-action:hover,
.header-action:focus-visible {
  color: #fff;
}

.header-action > .fa:first-child {
  color: #8eaff4;
  font-size: 0.95rem;
}

.resources-dropdown .dropdown-toggle::after {
  margin-left: 0.25rem;
  vertical-align: 0.15em;
}

.resources-menu {
  min-width: 220px;
  margin-top: 0.65rem;
  padding: 0.45rem;
  background: #0c1e45;
  border: 1px solid rgba(167, 192, 239, 0.2);
  border-radius: var(--ca-radius-md, 8px);
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.3);
}

.resources-menu__item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 0.8rem;
  color: #d7e2f5;
  background: transparent;
  border: 0;
  border-radius: 6px;
  font-size: 0.86rem;
  text-align: left;
  cursor: pointer;
}

.resources-menu__item > .fa:first-child {
  width: 18px;
  color: #8eaff4;
  text-align: center;
}

.resources-menu__item:hover,
.resources-menu__item:focus-visible {
  color: #fff;
  background: rgba(40, 80, 173, 0.3);
}

.resources-menu__external {
  margin-left: auto;
  color: #8eaff4;
  font-size: 0.72rem;
}

.user-management-btn {
  justify-content: center;
  gap: 0.6rem;
  min-height: 40px;
  padding: 0.62rem 0.95rem;
  color: #eff5ff;
  background: rgba(40, 80, 173, 0.18);
  border: 1px solid rgba(126, 164, 235, 0.35);
  border-radius: var(--ca-radius-sm, 6px);
  font: inherit;
  font-size: 0.83rem;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 180ms ease, border-color 180ms ease, transform 180ms ease;
}

.user-management-btn > .fa {
  color: #a9c4ff;
}

.user-management-btn:not(:disabled):hover {
  background: rgba(40, 80, 173, 0.38);
  border-color: rgba(169, 196, 255, 0.65);
  transform: translateY(-1px);
}

.user-management-btn:disabled {
  color: #8a98b1;
  background: rgba(255, 255, 255, 0.035);
  border-color: rgba(255, 255, 255, 0.08);
  cursor: not-allowed;
  opacity: 0.72;
}

.user-management-btn:disabled > .fa {
  color: #8795af;
}

.profile-slot {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
}

.home-root {
  position: relative;
  isolation: isolate;
  min-height: calc(100vh - 78px);
  overflow: hidden;
  color: #fff;
  background: radial-gradient(ellipse at 80% 8%, rgba(40, 80, 173, 0.28), transparent 34%), linear-gradient(135deg, var(--ca-sidebar-bg, #07112e) 0%, var(--ca-sidebar-bg-secondary, #041b38) 58%, #06112b 100%);
}

.home-root::before,
.home-root::after {
  position: absolute;
  z-index: -1;
  inset: 0;
  content: "";
  pointer-events: none;
}

.home-root::before {
  background: radial-gradient(circle at 12% 38%, rgba(40, 80, 173, 0.13), transparent 27%), radial-gradient(circle at 88% 60%, rgba(14, 46, 128, 0.18), transparent 30%);
}

.home-root::after {
  inset: 0;
  background-image: linear-gradient(rgba(174, 198, 240, 0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(174, 198, 240, 0.035) 1px, transparent 1px);
  background-size: 52px 52px;
  opacity: 0.45;
  mask-image: linear-gradient(to bottom, black, transparent 82%);
}

.products-page {
  position: relative;
  z-index: 1;
  width: min(100%, 1600px);
  margin: 0 auto;
  padding: clamp(1.5rem, 2.8vw, 2.25rem) clamp(1rem, 4vw, 3.5rem) 1.5rem;
}

.products-intro,
.products-section {
  letter-spacing: normal;
  line-height: 1.5;
}

/* Compact page introduction: deliberately no hero artwork or CTA. */
.products-intro {
  width: min(100%, 760px);
  margin: 0 auto clamp(2rem, 4vw, 3rem);
  padding: 0.25rem 0 0;
  text-align: center;
}

.products-intro__title {
  margin: 0;
  color: #f8fbff;
  font-size: clamp(2rem, 3.5vw, 2.7rem);
  font-weight: 750;
  letter-spacing: -0.045em;
  line-height: 1.15;
}

.products-intro__title span {
  color: var(--ca-primary-light, #91b5ff);
  background: linear-gradient(100deg, #d7e5ff 0%, #83aaff 48%, #6687f2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.products-intro__description {
  max-width: 620px;
  margin: 0.7rem auto 0;
  color: #bdcbe3;
  font-size: 1rem;
  line-height: 1.7;
}

.products-section__heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.section-kicker {
  margin-bottom: 0.55rem;
  color: #88a9ed;
}

.section-title {
  margin: 0;
  color: #f5f8ff;
  font-size: clamp(1.6rem, 2.5vw, 2.15rem);
  font-weight: 650;
  letter-spacing: -0.035em;
  line-height: 1.2;
}

.section-description {
  margin: 0.6rem 0 0;
  color: #9eafcc;
  font-size: 0.92rem;
}

.product-count {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  flex: 0 0 auto;
  padding: 0.55rem 0.8rem;
  color: #aebfdd;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(175, 198, 239, 0.13);
  border-radius: 9px;
}

.product-count__number {
  color: #e8efff;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.product-count__label {
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.15rem;
}

.product-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 300px;
  padding: 1.4rem 1.4rem 1.25rem;
  overflow: hidden;
  background: linear-gradient(145deg, rgba(16, 37, 82, 0.9), rgba(6, 22, 52, 0.94));
  border: 1px solid rgba(159, 187, 240, 0.18);
  border-radius: var(--ca-radius-lg, 12px);
  box-shadow: 0 16px 38px rgba(0, 0, 0, 0.13);
  transition: transform 220ms ease, border-color 220ms ease, box-shadow 220ms ease, background-color 220ms ease;
}

.product-card::before {
  position: absolute;
  top: -58px;
  right: -48px;
  width: 155px;
  height: 155px;
  content: "";
  pointer-events: none;
  transition: opacity 220ms ease, transform 220ms ease;
}

.product-card::after {
  position: absolute;
  top: 0;
  left: 1.4rem;
  width: 58px;
  height: 2px;
  background: linear-gradient(90deg, #729cf2, transparent);
  content: "";
  opacity: 0.75;
}

.product-card:hover {
  background: linear-gradient(145deg, rgba(20, 45, 98, 0.96), rgba(7, 24, 57, 0.98));
  border-color: rgba(143, 177, 248, 0.48);
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.24), 0 0 0 1px rgba(72, 117, 211, 0.08);
  transform: translateY(-5px);
}

.product-card:hover::before {
  transform: scale(1.25);
}

.product-card:focus-within {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: 3px;
}

.product-card__topline {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.15rem;
}

.product-icon {
  display: inline-grid;
  place-items: center;
  width: 54px;
  height: 54px;
  color: #c9dcff;
  background: rgba(40, 80, 173, 0.2);
  border: 1px solid rgba(139, 172, 242, 0.28);
  border-radius: 15px;
  font-size: 1.35rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.07);
}

.product-icon--assets {
  color: #9fc4ff;
  background: rgba(54, 111, 204, 0.18);
}

.product-icon--access {
  color: #b8b9ff;
  background: rgba(102, 90, 208, 0.16);
}

.product-icon--data {
  color: #8be0d4;
  background: rgba(41, 155, 147, 0.15);
}

.product-icon--identity {
  color: #edc7ff;
  background: rgba(151, 83, 197, 0.16);
}

.product-icon--zone {
  color: #ffd69b;
  background: rgba(196, 135, 47, 0.15);
}

.product-icon--blockchain {
  color: #a9d5ff;
  background: rgba(59, 133, 196, 0.16);
}

.product-icon--egrc {
  color: #bfe7ad;
  background: rgba(92, 155, 73, 0.15);
}

.product-index {
  align-self: flex-start;
  color: rgba(187, 204, 235, 0.55);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
}

.product-eyebrow {
  position: relative;
  z-index: 1;
  margin-bottom: 0.45rem;
  color: #91ace5;
  font-size: 0.62rem;
  letter-spacing: 0.12em;
}

.product-title {
  position: relative;
  z-index: 1;
  margin: 0;
  color: #f4f7ff;
  font-size: 1.17rem;
  font-weight: 650;
  letter-spacing: -0.02em;
  line-height: 1.35;
}

.product-description {
  position: relative;
  z-index: 1;
  margin: 0.7rem 0 1.25rem;
  color: #b5c3dd;
  font-size: 0.84rem;
  line-height: 1.7;
}

.product-action {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  min-height: 42px;
  margin-top: auto;
  padding: 0.7rem 0.8rem;
  color: #dce8ff;
  background: rgba(40, 80, 173, 0.13);
  border: 1px solid rgba(121, 158, 231, 0.23);
  border-radius: var(--ca-radius-sm, 6px);
  font: inherit;
  font-size: 0.8rem;
  font-weight: 600;
  text-align: left;
  cursor: pointer;
  transition: color 180ms ease, background-color 180ms ease, border-color 180ms ease;
}

.product-action .fa {
  color: #9bbaff;
  font-size: 0.86rem;
  transition: transform 180ms ease;
}

.product-action:hover {
  color: #fff;
  background: rgba(40, 80, 173, 0.38);
  border-color: rgba(146, 179, 247, 0.48);
}

.product-action:hover .fa {
  color: #fff;
  transform: translateX(3px);
}

.product-action:focus-visible,
.user-management-btn:focus-visible,
.logout-button:focus-visible,
.header-action:focus-visible,
.products-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: clamp(2.25rem, 5vw, 4rem);
  padding: 1.25rem 0 0.5rem;
  border-top: 1px solid rgba(174, 198, 239, 0.13);
}

.products-footer__brand {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin: 0;
  color: #8fa1bf;
  font-size: 0.78rem;
}

.footer-mark {
  display: inline-block;
  width: 7px;
  height: 7px;
  background: #6f99ed;
  border-radius: 2px;
  box-shadow: 0 0 10px rgba(111, 153, 237, 0.55);
  transform: rotate(45deg);
}

.products-footer__separator {
  color: #536685;
}

.logout-button {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.55rem 0.7rem;
  color: #aebdd5;
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--ca-radius-sm, 6px);
  font: inherit;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: color 180ms ease, background-color 180ms ease, border-color 180ms ease;
}

.logout-button:hover {
  color: #fff;
  background: rgba(220, 75, 91, 0.1);
  border-color: rgba(220, 75, 91, 0.25);
}

.logout-button .fa {
  color: #e39ba6;
}

@media (max-width: 1100px) {
  .products-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .brand-lockup__caption {
    display: none;
  }
}
@media (max-width: 760px) {
  .products-header__inner {
    min-height: 70px;
    gap: 0.75rem;
    padding-inline: 1rem;
  }
  .brand-lockup {
    gap: 0.65rem;
  }
  .brand-lockup__logo {
    max-width: 135px;
    height: 34px;
  }
  .header-actions {
    gap: 0.55rem;
  }
  .header-action {
    padding: 0.55rem 0.2rem;
  }
  .header-action span {
    display: none;
  }
  .resources-dropdown .dropdown-toggle::after {
    display: none;
  }
  .user-management-btn {
    width: 40px;
    min-width: 40px;
    height: 40px;
    padding: 0;
  }
  .user-management-btn span {
    display: none;
  }
  .header-actions__divider {
    height: 24px;
  }
  .products-page {
    padding-top: 1.5rem;
  }
  .products-intro {
    margin-bottom: 2.25rem;
  }
  .products-intro__title {
    font-size: clamp(1.9rem, 7vw, 2.4rem);
  }
  .products-intro__description {
    max-width: 540px;
    font-size: 0.9rem;
  }
  .products-section__heading {
    align-items: flex-start;
  }
  .products-grid {
    gap: 0.9rem;
  }
  .product-card {
    min-height: 290px;
    padding: 1.15rem;
  }
  .product-card::after {
    left: 1.15rem;
  }
}
@media (max-width: 540px) {
  .products-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .products-section__heading {
    gap: 0.75rem;
  }
  .product-count {
    gap: 0.4rem;
    padding: 0.45rem 0.55rem;
  }
  .product-count__label {
    font-size: 0.57rem;
  }
  .products-footer {
    align-items: flex-start;
  }
  .products-footer__brand {
    flex-wrap: wrap;
    gap: 0.4rem;
    max-width: 75%;
    line-height: 1.6;
  }
}
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    scroll-behavior: auto !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/home/home.component.scss"],"names":[],"mappings":"AACA;EACE,cAAA;EACA,iBAAA;EACA,WAAA;AAAF;;AAGA,wEAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iCAAA;EACA,kDAAA;EACA,2CAAA;EAEA,2BAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;AAAF;;AAGA;;;;EAIE,oBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,SAAA;EACA,YAAA;AAAF;;AAGA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AAAF;;AAGA;;EAEE,UAAA;EACA,YAAA;EACA,qCAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,kCAAA;EACA,YAAA;AAAF;;AAGA;EACE,YAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,4BAAA;AAAF;;AAGA;;EAEE,WAAA;AAAF;;AAGA;EACE,cAAA;EACA,kBAAA;AAAF;;AAGA;EACE,oBAAA;EACA,sBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,uCAAA;EACA,0CAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,cAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,WAAA;EACA,cAAA;EACA,kBAAA;AAAF;;AAGA;;EAEE,WAAA;EACA,kCAAA;AAAF;;AAGA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;AAAF;;AAGA;EACE,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,mCAAA;EACA,2CAAA;EACA,uCAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,sFAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,mCAAA;EACA,uCAAA;EACA,2BAAA;AAAF;;AAGA;EACE,cAAA;EACA,sCAAA;EACA,uCAAA;EACA,mBAAA;EACA,aAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;EACA,8MACE;AADJ;;AAKA;;EAEE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,WAAA;EACA,oBAAA;AAFF;;AAKA;EACE,sKACE;AAHJ;;AAOA;EACE,QAAA;EACA,2JAAA;EAEA,0BAAA;EACA,aAAA;EACA,8DAAA;AALF;;AAQA;EACE,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,cAAA;EACA,sEAAA;AALF;;AAQA;;EAEE,sBAAA;EACA,gBAAA;AALF;;AAQA,oEAAA;AACA;EACE,uBAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AALF;;AAQA;EACE,SAAA;EACA,cAAA;EACA,qCAAA;EACA,gBAAA;EACA,wBAAA;EACA,iBAAA;AALF;;AAQA;EACE,uCAAA;EACA,0EAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;AALF;;AAQA;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AALF;;AAQA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AALF;;AAQA;EACE,sBAAA;EACA,cAAA;AALF;;AAQA;EACE,SAAA;EACA,cAAA;EACA,wCAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;AALF;;AAQA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA;EACA,cAAA;EACA,qCAAA;EACA,2CAAA;EACA,kBAAA;AALF;;AAQA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AALF;;AAQA;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;AALF;;AAQA;EACE,aAAA;EACA,gDAAA;EACA,YAAA;AALF;;AAQA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,gBAAA;EACA,iFAAA;EACA,2CAAA;EACA,wCAAA;EACA,2CAAA;EACA,6GAAA;AALF;;AAQA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EAEA,WAAA;EACA,oBAAA;EACA,oDAAA;AANF;;AASA;EACE,kBAAA;EACA,MAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,wDAAA;EACA,WAAA;EACA,aAAA;AANF;;AASA;EACE,kFAAA;EACA,uCAAA;EACA,+EAAA;EACA,2BAAA;AANF;;AASA;EACE,sBAAA;AANF;;AASA;EACE,mDAAA;EACA,mBAAA;AANF;;AASA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;AANF;;AASA;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kCAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;EACA,mDAAA;AANF;;AASA;EAAwB,cAAA;EAAgB,oCAAA;AAJxC;;AAKA;EAAwB,cAAA;EAAgB,oCAAA;AAAxC;;AACA;EAAsB,cAAA;EAAgB,oCAAA;AAItC;;AAHA;EAA0B,cAAA;EAAgB,oCAAA;AAQ1C;;AAPA;EAAsB,cAAA;EAAgB,oCAAA;AAYtC;;AAXA;EAA4B,cAAA;EAAgB,oCAAA;AAgB5C;;AAfA;EAAsB,cAAA;EAAgB,mCAAA;AAoBtC;;AAlBA;EACE,sBAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;AAqBF;;AAlBA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;AAqBF;;AAlBA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AAqBF;;AAlBA;EACE,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAqBF;;AAlBA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,mCAAA;EACA,2CAAA;EACA,uCAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kFAAA;AAqBF;;AAlBA;EACE,cAAA;EACA,kBAAA;EACA,gCAAA;AAqBF;;AAlBA;EACE,WAAA;EACA,mCAAA;EACA,uCAAA;AAqBF;;AAlBA;EACE,WAAA;EACA,0BAAA;AAqBF;;AAlBA;;;;;EAKE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,qCAAA;EACA,yBAAA;EACA,+CAAA;AAqBF;;AAlBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;EACA,kBAAA;AAqBF;;AAlBA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,8CAAA;EACA,wBAAA;AAqBF;;AAlBA;EACE,cAAA;AAqBF;;AAlBA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,uBAAA;EACA,6BAAA;EACA,uCAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,kFAAA;AAqBF;;AAlBA;EACE,WAAA;EACA,kCAAA;EACA,qCAAA;AAqBF;;AAlBA;EACE,cAAA;AAqBF;;AAlBA;EACE;IACE,gDAAA;EAqBF;EAlBA;IACE,aAAA;EAoBF;AACF;AAjBA;EACE;IACE,gBAAA;IACA,YAAA;IACA,oBAAA;EAmBF;EAhBA;IACE,YAAA;EAkBF;EAfA;IACE,gBAAA;IACA,YAAA;EAiBF;EAdA;IACE,YAAA;EAgBF;EAbA;IACE,uBAAA;EAeF;EAZA;IACE,aAAA;EAcF;EAXA;IACE,aAAA;EAaF;EAVA;IACE,WAAA;IACA,eAAA;IACA,YAAA;IACA,UAAA;EAYF;EATA;IACE,aAAA;EAWF;EARA;IACE,YAAA;EAUF;EAPA;IACE,mBAAA;EASF;EANA;IACE,sBAAA;EAQF;EALA;IACE,qCAAA;EAOF;EAJA;IACE,gBAAA;IACA,iBAAA;EAMF;EAHA;IACE,uBAAA;EAKF;EAFA;IACE,WAAA;EAIF;EADA;IACE,iBAAA;IACA,gBAAA;EAGF;EAAA;IACE,aAAA;EAEF;AACF;AACA;EACE;IACE,qCAAA;EACF;EAEA;IACE,YAAA;EAAF;EAGA;IACE,WAAA;IACA,wBAAA;EADF;EAIA;IACE,kBAAA;EAFF;EAKA;IACE,uBAAA;EAHF;EAMA;IACE,eAAA;IACA,WAAA;IACA,cAAA;IACA,gBAAA;EAJF;AACF;AAOA;EACE;;;IAGE,gCAAA;IACA,qCAAA;IACA,uCAAA;IACA,sCAAA;EALF;AACF","sourcesContent":["\r\n:host {\r\n  display: block;\r\n  min-height: 100vh;\r\n  color: #fff;\r\n}\r\n\r\n/* The page consumes the shared --ca-* design tokens from styles.scss. */\r\n.products-header {\r\n  position: relative;\r\n  z-index: 5;\r\n  width: 100%;\r\n  background: rgba(7, 17, 46, 0.96);\r\n  border-bottom: 1px solid rgba(185, 205, 242, 0.14);\r\n  box-shadow: 0 8px 28px rgba(1, 8, 23, 0.12);\r\n  -webkit-backdrop-filter: blur(18px);\r\n  backdrop-filter: blur(18px);\r\n}\r\n\r\n.products-header__inner {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1.5rem;\r\n  width: min(100%, 1600px);\r\n  min-height: 78px;\r\n  margin: 0 auto;\r\n  padding: 0 clamp(1rem, 4vw, 3.5rem);\r\n}\r\n\r\n.brand-lockup,\r\n.header-actions,\r\n.header-action,\r\n.user-management-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.brand-lockup {\r\n  flex: 0 1 auto;\r\n  gap: 1rem;\r\n  min-width: 0;\r\n}\r\n\r\n.brand-lockup__logo {\r\n  display: block;\r\n  width: auto;\r\n  max-width: 160px;\r\n  height: 38px;\r\n  object-fit: contain;\r\n}\r\n\r\n.brand-lockup__divider,\r\n.header-actions__divider {\r\n  width: 1px;\r\n  height: 28px;\r\n  background: rgba(220, 229, 245, 0.22);\r\n}\r\n\r\n.brand-lockup__caption {\r\n  color: #aabbd9;\r\n  font-size: 0.67rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.13em;\r\n  white-space: nowrap;\r\n}\r\n\r\n.header-actions {\r\n  justify-content: flex-end;\r\n  gap: clamp(0.6rem, 1.5vw, 1.35rem);\r\n  min-width: 0;\r\n}\r\n\r\n.header-action {\r\n  gap: 0.55rem;\r\n  padding: 0.7rem 0.25rem;\r\n  color: #d7e2f5;\r\n  font-size: 0.86rem;\r\n  font-weight: 500;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  transition: color 180ms ease;\r\n}\r\n\r\n.header-action:hover,\r\n.header-action:focus-visible {\r\n  color: #fff;\r\n}\r\n\r\n.header-action > .fa:first-child {\r\n  color: #8eaff4;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.resources-dropdown .dropdown-toggle::after {\r\n  margin-left: 0.25rem;\r\n  vertical-align: 0.15em;\r\n}\r\n\r\n.resources-menu {\r\n  min-width: 220px;\r\n  margin-top: 0.65rem;\r\n  padding: 0.45rem;\r\n  background: #0c1e45;\r\n  border: 1px solid rgba(167, 192, 239, 0.2);\r\n  border-radius: var(--ca-radius-md, 8px);\r\n  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.resources-menu__item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  width: 100%;\r\n  padding: 0.75rem 0.8rem;\r\n  color: #d7e2f5;\r\n  background: transparent;\r\n  border: 0;\r\n  border-radius: 6px;\r\n  font-size: 0.86rem;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n\r\n.resources-menu__item > .fa:first-child {\r\n  width: 18px;\r\n  color: #8eaff4;\r\n  text-align: center;\r\n}\r\n\r\n.resources-menu__item:hover,\r\n.resources-menu__item:focus-visible {\r\n  color: #fff;\r\n  background: rgba(40, 80, 173, 0.3);\r\n}\r\n\r\n.resources-menu__external {\r\n  margin-left: auto;\r\n  color: #8eaff4;\r\n  font-size: 0.72rem;\r\n}\r\n\r\n.user-management-btn {\r\n  justify-content: center;\r\n  gap: 0.6rem;\r\n  min-height: 40px;\r\n  padding: 0.62rem 0.95rem;\r\n  color: #eff5ff;\r\n  background: rgba(40, 80, 173, 0.18);\r\n  border: 1px solid rgba(126, 164, 235, 0.35);\r\n  border-radius: var(--ca-radius-sm, 6px);\r\n  font: inherit;\r\n  font-size: 0.83rem;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n  transition: background-color 180ms ease, border-color 180ms ease, transform 180ms ease;\r\n}\r\n\r\n.user-management-btn > .fa {\r\n  color: #a9c4ff;\r\n}\r\n\r\n.user-management-btn:not(:disabled):hover {\r\n  background: rgba(40, 80, 173, 0.38);\r\n  border-color: rgba(169, 196, 255, 0.65);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.user-management-btn:disabled {\r\n  color: #8a98b1;\r\n  background: rgba(255, 255, 255, 0.035);\r\n  border-color: rgba(255, 255, 255, 0.08);\r\n  cursor: not-allowed;\r\n  opacity: 0.72;\r\n}\r\n\r\n.user-management-btn:disabled > .fa {\r\n  color: #8795af;\r\n}\r\n\r\n.profile-slot {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  flex: 0 0 auto;\r\n}\r\n\r\n.home-root {\r\n  position: relative;\r\n  isolation: isolate;\r\n  min-height: calc(100vh - 78px);\r\n  overflow: hidden;\r\n  color: #fff;\r\n  background:\r\n    radial-gradient(ellipse at 80% 8%, rgba(40, 80, 173, 0.28), transparent 34%),\r\n    linear-gradient(135deg, var(--ca-sidebar-bg, #07112e) 0%, var(--ca-sidebar-bg-secondary, #041b38) 58%, #06112b 100%);\r\n}\r\n\r\n.home-root::before,\r\n.home-root::after {\r\n  position: absolute;\r\n  z-index: -1;\r\n  inset: 0;\r\n  content: '';\r\n  pointer-events: none;\r\n}\r\n\r\n.home-root::before {\r\n  background:\r\n    radial-gradient(circle at 12% 38%, rgba(40, 80, 173, 0.13), transparent 27%),\r\n    radial-gradient(circle at 88% 60%, rgba(14, 46, 128, 0.18), transparent 30%);\r\n}\r\n\r\n.home-root::after {\r\n  inset: 0;\r\n  background-image: linear-gradient(rgba(174, 198, 240, 0.035) 1px, transparent 1px),\r\n    linear-gradient(90deg, rgba(174, 198, 240, 0.035) 1px, transparent 1px);\r\n  background-size: 52px 52px;\r\n  opacity: 0.45;\r\n  mask-image: linear-gradient(to bottom, black, transparent 82%);\r\n}\r\n\r\n.products-page {\r\n  position: relative;\r\n  z-index: 1;\r\n  width: min(100%, 1600px);\r\n  margin: 0 auto;\r\n  padding: clamp(1.5rem, 2.8vw, 2.25rem) clamp(1rem, 4vw, 3.5rem) 1.5rem;\r\n}\r\n\r\n.products-intro,\r\n.products-section {\r\n  letter-spacing: normal;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Compact page introduction: deliberately no hero artwork or CTA. */\r\n.products-intro {\r\n  width: min(100%, 760px);\r\n  margin: 0 auto clamp(2rem, 4vw, 3rem);\r\n  padding: 0.25rem 0 0;\r\n  text-align: center;\r\n}\r\n\r\n.products-intro__title {\r\n  margin: 0;\r\n  color: #f8fbff;\r\n  font-size: clamp(2rem, 3.5vw, 2.7rem);\r\n  font-weight: 750;\r\n  letter-spacing: -0.045em;\r\n  line-height: 1.15;\r\n}\r\n\r\n.products-intro__title span {\r\n  color: var(--ca-primary-light, #91b5ff);\r\n  background: linear-gradient(100deg, #d7e5ff 0%, #83aaff 48%, #6687f2 100%);\r\n  background-clip: text;\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n}\r\n\r\n.products-intro__description {\r\n  max-width: 620px;\r\n  margin: 0.7rem auto 0;\r\n  color: #bdcbe3;\r\n  font-size: 1rem;\r\n  line-height: 1.7;\r\n}\r\n\r\n.products-section__heading {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 1.5rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.section-kicker {\r\n  margin-bottom: 0.55rem;\r\n  color: #88a9ed;\r\n}\r\n\r\n.section-title {\r\n  margin: 0;\r\n  color: #f5f8ff;\r\n  font-size: clamp(1.6rem, 2.5vw, 2.15rem);\r\n  font-weight: 650;\r\n  letter-spacing: -0.035em;\r\n  line-height: 1.2;\r\n}\r\n\r\n.section-description {\r\n  margin: 0.6rem 0 0;\r\n  color: #9eafcc;\r\n  font-size: 0.92rem;\r\n}\r\n\r\n.product-count {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.65rem;\r\n  flex: 0 0 auto;\r\n  padding: 0.55rem 0.8rem;\r\n  color: #aebfdd;\r\n  background: rgba(255, 255, 255, 0.04);\r\n  border: 1px solid rgba(175, 198, 239, 0.13);\r\n  border-radius: 9px;\r\n}\r\n\r\n.product-count__number {\r\n  color: #e8efff;\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.product-count__label {\r\n  font-size: 0.64rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.12em;\r\n}\r\n\r\n.products-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: 1.15rem;\r\n}\r\n\r\n.product-card {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  min-height: 300px;\r\n  padding: 1.4rem 1.4rem 1.25rem;\r\n  overflow: hidden;\r\n  background: linear-gradient(145deg, rgba(16, 37, 82, 0.9), rgba(6, 22, 52, 0.94));\r\n  border: 1px solid rgba(159, 187, 240, 0.18);\r\n  border-radius: var(--ca-radius-lg, 12px);\r\n  box-shadow: 0 16px 38px rgba(0, 0, 0, 0.13);\r\n  transition: transform 220ms ease, border-color 220ms ease, box-shadow 220ms ease, background-color 220ms ease;\r\n}\r\n\r\n.product-card::before {\r\n  position: absolute;\r\n  top: -58px;\r\n  right: -48px;\r\n  width: 155px;\r\n  height: 155px;\r\n // background: radial-gradient(circle, rgba(74, 115, 204, 0.19), transparent 68%);\r\n  content: '';\r\n  pointer-events: none;\r\n  transition: opacity 220ms ease, transform 220ms ease;\r\n}\r\n\r\n.product-card::after {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 1.4rem;\r\n  width: 58px;\r\n  height: 2px;\r\n  background: linear-gradient(90deg, #729cf2, transparent);\r\n  content: '';\r\n  opacity: 0.75;\r\n}\r\n\r\n.product-card:hover {\r\n  background: linear-gradient(145deg, rgba(20, 45, 98, 0.96), rgba(7, 24, 57, 0.98));\r\n  border-color: rgba(143, 177, 248, 0.48);\r\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.24), 0 0 0 1px rgba(72, 117, 211, 0.08);\r\n  transform: translateY(-5px);\r\n}\r\n\r\n.product-card:hover::before {\r\n  transform: scale(1.25);\r\n}\r\n\r\n.product-card:focus-within {\r\n  outline: 2px solid var(--ca-primary-light, #2850ad);\r\n  outline-offset: 3px;\r\n}\r\n\r\n.product-card__topline {\r\n  position: relative;\r\n  z-index: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 1.15rem;\r\n}\r\n\r\n.product-icon {\r\n  display: inline-grid;\r\n  place-items: center;\r\n  width: 54px;\r\n  height: 54px;\r\n  color: #c9dcff;\r\n  background: rgba(40, 80, 173, 0.2);\r\n  border: 1px solid rgba(139, 172, 242, 0.28);\r\n  border-radius: 15px;\r\n  font-size: 1.35rem;\r\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.07);\r\n}\r\n\r\n.product-icon--assets { color: #9fc4ff; background: rgba(54, 111, 204, 0.18); }\r\n.product-icon--access { color: #b8b9ff; background: rgba(102, 90, 208, 0.16); }\r\n.product-icon--data { color: #8be0d4; background: rgba(41, 155, 147, 0.15); }\r\n.product-icon--identity { color: #edc7ff; background: rgba(151, 83, 197, 0.16); }\r\n.product-icon--zone { color: #ffd69b; background: rgba(196, 135, 47, 0.15); }\r\n.product-icon--blockchain { color: #a9d5ff; background: rgba(59, 133, 196, 0.16); }\r\n.product-icon--egrc { color: #bfe7ad; background: rgba(92, 155, 73, 0.15); }\r\n\r\n.product-index {\r\n  align-self: flex-start;\r\n  color: rgba(187, 204, 235, 0.55);\r\n  font-size: 0.75rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.12em;\r\n}\r\n\r\n.product-eyebrow {\r\n  position: relative;\r\n  z-index: 1;\r\n  margin-bottom: 0.45rem;\r\n  color: #91ace5;\r\n  font-size: 0.62rem;\r\n  letter-spacing: 0.12em;\r\n}\r\n\r\n.product-title {\r\n  position: relative;\r\n  z-index: 1;\r\n  margin: 0;\r\n  color: #f4f7ff;\r\n  font-size: 1.17rem;\r\n  font-weight: 650;\r\n  letter-spacing: -0.02em;\r\n  line-height: 1.35;\r\n}\r\n\r\n.product-description {\r\n  position: relative;\r\n  z-index: 1;\r\n  margin: 0.7rem 0 1.25rem;\r\n  color: #b5c3dd;\r\n  font-size: 0.84rem;\r\n  line-height: 1.7;\r\n}\r\n\r\n.product-action {\r\n  position: relative;\r\n  z-index: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.75rem;\r\n  width: 100%;\r\n  min-height: 42px;\r\n  margin-top: auto;\r\n  padding: 0.7rem 0.8rem;\r\n  color: #dce8ff;\r\n  background: rgba(40, 80, 173, 0.13);\r\n  border: 1px solid rgba(121, 158, 231, 0.23);\r\n  border-radius: var(--ca-radius-sm, 6px);\r\n  font: inherit;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: color 180ms ease, background-color 180ms ease, border-color 180ms ease;\r\n}\r\n\r\n.product-action .fa {\r\n  color: #9bbaff;\r\n  font-size: 0.86rem;\r\n  transition: transform 180ms ease;\r\n}\r\n\r\n.product-action:hover {\r\n  color: #fff;\r\n  background: rgba(40, 80, 173, 0.38);\r\n  border-color: rgba(146, 179, 247, 0.48);\r\n}\r\n\r\n.product-action:hover .fa {\r\n  color: #fff;\r\n  transform: translateX(3px);\r\n}\r\n\r\n.product-action:focus-visible,\r\n.user-management-btn:focus-visible,\r\n.logout-button:focus-visible,\r\n.header-action:focus-visible,\r\n.products-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  margin-top: clamp(2.25rem, 5vw, 4rem);\r\n  padding: 1.25rem 0 0.5rem;\r\n  border-top: 1px solid rgba(174, 198, 239, 0.13);\r\n}\r\n\r\n.products-footer__brand {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.55rem;\r\n  margin: 0;\r\n  color: #8fa1bf;\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.footer-mark {\r\n  display: inline-block;\r\n  width: 7px;\r\n  height: 7px;\r\n  background: #6f99ed;\r\n  border-radius: 2px;\r\n  box-shadow: 0 0 10px rgba(111, 153, 237, 0.55);\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.products-footer__separator {\r\n  color: #536685;\r\n}\r\n\r\n.logout-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.55rem;\r\n  padding: 0.55rem 0.7rem;\r\n  color: #aebdd5;\r\n  background: transparent;\r\n  border: 1px solid transparent;\r\n  border-radius: var(--ca-radius-sm, 6px);\r\n  font: inherit;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: color 180ms ease, background-color 180ms ease, border-color 180ms ease;\r\n}\r\n\r\n.logout-button:hover {\r\n  color: #fff;\r\n  background: rgba(220, 75, 91, 0.1);\r\n  border-color: rgba(220, 75, 91, 0.25);\r\n}\r\n\r\n.logout-button .fa {\r\n  color: #e39ba6;\r\n}\r\n\r\n@media (max-width: 1100px) {\r\n  .products-grid {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n\r\n  .brand-lockup__caption {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 760px) {\r\n  .products-header__inner {\r\n    min-height: 70px;\r\n    gap: 0.75rem;\r\n    padding-inline: 1rem;\r\n  }\r\n\r\n  .brand-lockup {\r\n    gap: 0.65rem;\r\n  }\r\n\r\n  .brand-lockup__logo {\r\n    max-width: 135px;\r\n    height: 34px;\r\n  }\r\n\r\n  .header-actions {\r\n    gap: 0.55rem;\r\n  }\r\n\r\n  .header-action {\r\n    padding: 0.55rem 0.2rem;\r\n  }\r\n\r\n  .header-action span {\r\n    display: none;\r\n  }\r\n\r\n  .resources-dropdown .dropdown-toggle::after {\r\n    display: none;\r\n  }\r\n\r\n  .user-management-btn {\r\n    width: 40px;\r\n    min-width: 40px;\r\n    height: 40px;\r\n    padding: 0;\r\n  }\r\n\r\n  .user-management-btn span {\r\n    display: none;\r\n  }\r\n\r\n  .header-actions__divider {\r\n    height: 24px;\r\n  }\r\n\r\n  .products-page {\r\n    padding-top: 1.5rem;\r\n  }\r\n\r\n  .products-intro {\r\n    margin-bottom: 2.25rem;\r\n  }\r\n\r\n  .products-intro__title {\r\n    font-size: clamp(1.9rem, 7vw, 2.4rem);\r\n  }\r\n\r\n  .products-intro__description {\r\n    max-width: 540px;\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .products-section__heading {\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .products-grid {\r\n    gap: 0.9rem;\r\n  }\r\n\r\n  .product-card {\r\n    min-height: 290px;\r\n    padding: 1.15rem;\r\n  }\r\n\r\n  .product-card::after {\r\n    left: 1.15rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 540px) {\r\n  .products-grid {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .products-section__heading {\r\n    gap: 0.75rem;\r\n  }\r\n\r\n  .product-count {\r\n    gap: 0.4rem;\r\n    padding: 0.45rem 0.55rem;\r\n  }\r\n\r\n  .product-count__label {\r\n    font-size: 0.57rem;\r\n  }\r\n\r\n  .products-footer {\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .products-footer__brand {\r\n    flex-wrap: wrap;\r\n    gap: 0.4rem;\r\n    max-width: 75%;\r\n    line-height: 1.6;\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    scroll-behavior: auto !important;\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
